import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import BaseService from "../base/BaseService";

export default class FlashCardBookmark extends BaseService {
    create(boxId: string, cardId: string): Promise<any> {
        return axios.post(`/FlashCardBookmark/${boxId}/${cardId}`)
            .then(function (response: AxiosResponse<any, any>) {
                return response.data;
            });
    }

    getPaged(boxId: string): Promise<TitleValue<string>[]> {
        return axios.get(`/FlashCardBookmark/${boxId}`)
            .then(function (response: AxiosResponse<TitleValue<string>[], any>) {
                return response.data;
            });
    }
}   